
const readTextFile = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            return resolve(reader.result);
        }
        reader.onerror = (err) => {
            return reject(err)
        }
        reader.readAsText(file);
    })
}

const FileHelper = {
    readTextFile
}

export default FileHelper
